(function () {
  if (window.LovaviaSwiper) return;

  const stylesheetId = 'lovavia-swiper-css';
  const scriptId = 'lovavia-swiper-js';
  const stylesheetUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  const scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  window.LovaviaSwiper = {
    promise: null,

    load() {
      if (window.Swiper) return Promise.resolve(window.Swiper);
      if (this.promise) return this.promise;

      if (!document.getElementById(stylesheetId)) {
        const stylesheet = document.createElement('link');
        stylesheet.id = stylesheetId;
        stylesheet.rel = 'stylesheet';
        stylesheet.href = stylesheetUrl;
        document.head.appendChild(stylesheet);
      }

      this.promise = new Promise((resolve, reject) => {
        let script = document.getElementById(scriptId);

        const handleLoad = () => {
          if (window.Swiper) {
            resolve(window.Swiper);
          } else {
            this.promise = null;
            reject(new Error('Swiper loaded without exposing window.Swiper.'));
          }
        };

        const handleError = () => {
          this.promise = null;
          reject(new Error('Unable to load the Swiper library.'));
        };

        const isNewScript = !script;
        if (isNewScript) {
          script = document.createElement('script');
          script.id = scriptId;
          script.src = scriptUrl;
          script.async = true;
        }

        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });

        if (isNewScript) document.head.appendChild(script);
      });

      return this.promise;
    },
  };
})();
